import type { FC } from 'react'

import { PerformanceFeedbackEntriesFromOthersDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { EmptyState } from 'modules/performance_feedbacks/components/EmptyState'
import { FeedbackEntries } from 'modules/performance_feedbacks/components/FeedbackEntries'

const ReceivedFeedbackEmptyStateNoCTA: FC = () => {
  return (
    <EmptyState
      title={i18n.t('performance_feedbacks.empty_state.received_feedback.title_no_cta')}
      description={i18n.t('performance_feedbacks.empty_state.received_feedback.description_no_cta')}
      hasCTAButton={false}
    />
  )
}

const ReceivedFeedback = () => {
  const { access } = useCurrentSession()
  const { data } = useQuery(PerformanceFeedbackEntriesFromOthersDocument, {
    variables: {
      authorId: access.id,
    },
  })
  const feedbackEntries = data?.feedbacks.feedbackEntriesConnection.nodes

  return (
    <ResponsivePage.NestedBody>
      {/* TODO: changing the ReceivedFeedbackEmptyState to no CTA one until we have 'request feedback' functionality implemented */}
      {!feedbackEntries?.length && <ReceivedFeedbackEmptyStateNoCTA />}
      <FeedbackEntries entries={feedbackEntries || []} />
    </ResponsivePage.NestedBody>
  )
}

export default ReceivedFeedback
